module.exports = __webpack_public_path__ + "static/img/fourab.bafa6b56.png";